export default __webpack_public_path__ + "static/figure2-ed0f303d08e482684a1c2a1a1f42b762.webp";